import * as React from "react";
import type { SVGProps } from "react";
const SvgChecklist = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#checklist_svg__a)">
      <path d="M11 17h-.01c-.32 0-.62-.16-.8-.42l-2.5-3.5c-.32-.45-.22-1.07.23-1.4a.994.994 0 0 1 1.39.23l1.71 2.39 3.68-4.91c.33-.44.96-.53 1.4-.2s.53.96.2 1.4l-4.5 6c-.19.25-.49.4-.8.4z" />
      <path d="M19 22H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1H6v14h12V6h-3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1" />
      <path d="M15 7c-.55 0-1-.45-1-1 0-1.1-.9-2-2-2s-2 .9-2 2c0 .55-.45 1-1 1s-1-.45-1-1c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .55-.45 1-1 1" />
      <path d="M15 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="checklist_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChecklist;
